import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { logPageView } from "../lib/analytics";

export function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => {
    void logPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
}
